"use client";

import { useEffect, useRef } from "react";
import Icon from "@/components/ui/AppIcon";

export default function MissionVisionSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    const el = sectionRef?.current;
    if (el) el?.querySelectorAll(".reveal, .reveal-scale")?.forEach((i) => observer?.observe(i));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-28 bg-[#A8A8A8]">
      <div className="absolute top-0 left-0 right-0 gold-line" />

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="reveal text-[11px] font-display uppercase tracking-[0.2em] text-gold mb-3">
            Our Foundation
          </p>
          <h2 className="reveal delay-100 text-4xl md:text-5xl font-display font-700 text-[#0C1B33] tracking-tight">
            Mission &amp; Vision
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Mission */}
          <div className="reveal delay-100 service-card-ash rounded-2xl p-10 group">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-[rgba(201,168,76,0.12)] border border-[rgba(201,168,76,0.3)] flex items-center justify-center">
                <Icon name="RocketLaunchIcon" size={22} className="text-gold" />
              </div>
              <span className="text-[11px] font-display font-700 uppercase tracking-[0.2em] text-gold/80">
                Our Mission
              </span>
            </div>
            <h3 className="text-2xl font-display font-700 text-[#0C1B33] mb-4 leading-snug group-hover:text-gold transition-colors">
              Empowering Businesses Through Innovation
            </h3>
            <p className="text-[17px] font-body text-[#0C1B33]/65 leading-relaxed">
              To empower businesses with innovative operational strategies that enhance efficiency, profitability, and sustainable growth. We are committed to delivering solutions that create lasting competitive advantages for our clients.
            </p>
          </div>

          {/* Vision */}
          <div className="reveal delay-200 service-card-ash rounded-2xl p-10 group">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-[rgba(100,149,237,0.12)] border border-[rgba(100,149,237,0.25)] flex items-center justify-center">
                <Icon name="EyeIcon" size={22} className="text-blue-500" />
              </div>
              <span className="text-[11px] font-display font-700 uppercase tracking-[0.2em] text-blue-500/80">
                Our Vision
              </span>
            </div>
            <h3 className="text-2xl font-display font-700 text-[#0C1B33] mb-4 leading-snug group-hover:text-gold transition-colors">
              A Global Leader in Integrated Solutions
            </h3>
            <p className="text-[17px] font-body text-[#0C1B33]/65 leading-relaxed">
              To become a globally recognized leader in integrated asset management and supply chain optimization solutions — setting the standard for operational excellence across industries and geographies.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 gold-line" />
    </section>
  );
}